import React from 'react';
import ReactDOM from 'react-dom';
import ContactForm from './contact-form';
import MailingListForm from './mailing-list-form';
import MembersArea from "./members/members-area";
import AdminConsole from "./admin/admin-console";

if (document.getElementById('contactForm')) {
    ReactDOM.render(<ContactForm/>, document.getElementById('contactForm'));
}

if (document.getElementById('mailingListForm')) {
    ReactDOM.render(<MailingListForm/>, document.getElementById('mailingListForm'));
}

if (document.getElementById('membersArea')) {
    ReactDOM.render(<MembersArea/>, document.getElementById('membersArea'));
}

if (document.getElementById('adminConsole')) {
    ReactDOM.render(<AdminConsole/>, document.getElementById('adminConsole'));
}


// WEBPACK FOOTER //
// ./src/index.js